// AI Generated Test
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { PagePerformanceVersionService } from '@client/app/modules/page-performance/services/page-performance-version/page-performance-version.service';

@Component({
    selector: 'changes-history-dashboard-summary-performance',
    standalone: false,
    template: `
        <div class="changes-history-dashboard-summary-performance-container">
            <div class="ml-3">
                <span class="font-size-1-1 font-weight-500" translate>Average Performance score</span>
                <span class="mx-1">-</span>
                @let count = score.performance_page_count | monNumber;
                <span class="text-grey" translate [translate-n]="count" translate-plural="Total: [[$count]] Performance Pages">
                    Total: 1 Performance Page
                </span>
            </div>
            <div class="d-flex align-items-center">
                <div class="d-flex flex-wrap flex-sm-nowrap align-items-center">
                    <page-performance-score-doughnut-chart [score]="score.performance_score_average">
                    </page-performance-score-doughnut-chart>

                    <page-performance-score-indicators class="mx-6">
                    </page-performance-score-indicators>
                </div>
                <div class="flex-fill mb-md-4">
                    <div class="row">
                        <div class="offset-lg-5 offset-xl-8 col d-flex flex-wrap flex-column flex-md-row my-4">
                            <div class="checkpoint-container d-flex my-2 mr-2" *ngFor="let metric of metrics">
                                <span class="vertical-ruler vertical-ruler-left fmp-checkpoint-bg" [ngClass]="metric.rulerClass"></span>
                                <notification [title]="metric.title"
                                              [digit]="metric.data"
                                              [unit]="metric.unit">
                                </notification>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PerformanceComponent implements OnInit, OnChanges {
    @Input() history: any;
    @Input() domain: any;

    latestEntry: any = undefined;
    score: any;
    showV2Metrics = false;
    showFMP = false;
    metrics: any[] = [];

    constructor (
        private pipeService: PipeService,
        private pagePerformanceVersionService: PagePerformanceVersionService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngOnChanges () {
        this.update();
    }

    activate () {
        this.updateLatestEntry();
        this.score = this.getValue();
        this.showV2Metrics = false;
        this.showFMP = false;
        this.metrics = [];
        this.setShownMetrics();
    }

    update () {
        this.updateLatestEntry();
        this.score = this.getValue();
        this.setShownMetrics();
    }

    updateLatestEntry () {
        this.latestEntry = undefined;
        if (!this.history) {
            return;
        }

        const filtredHistory = this.history.filter((item: any) => Boolean(item['performance_version']));

        if (!filtredHistory || filtredHistory.length === 0) {
            return;
        }

        this.latestEntry = filtredHistory[filtredHistory.length - 1];
    }

    getValue () {
        const result = {
            performance_first_contentful_paint_average: null,
            performance_largest_contentful_paint_average: null,
            performance_first_meaningful_paint_average: null,
            performance_time_to_interactive_average: null,
            performance_speed_index_average: null,
            performance_total_blocking_time_average: null,
            performance_cumulative_layout_shift_average: null,
            performance_score_average: null,
            performance_page_count: null,
        };

        if (!this.latestEntry) {
            return result;
        }

        result.performance_first_contentful_paint_average = this.getFieldValue(this.latestEntry, 'performance_first_contentful_paint_average');
        result.performance_largest_contentful_paint_average = this.getFieldValue(this.latestEntry, 'performance_largest_contentful_paint_average');
        result.performance_first_meaningful_paint_average = this.getFieldValue(this.latestEntry, 'performance_first_meaningful_paint_average');
        result.performance_time_to_interactive_average = this.getFieldValue(this.latestEntry, 'performance_time_to_interactive_average');
        result.performance_speed_index_average = this.getFieldValue(this.latestEntry, 'performance_speed_index_average');
        result.performance_total_blocking_time_average = this.getFieldValue(this.latestEntry, 'performance_total_blocking_time_average');
        result.performance_cumulative_layout_shift_average = this.getFieldValue(this.latestEntry, 'performance_cumulative_layout_shift_average');
        result.performance_score_average = this.getFieldValue(this.latestEntry, 'performance_score_average');
        result.performance_page_count = this.getFieldValue(this.latestEntry, 'performance_page_count');

        return result;
    }

    getFieldValue (object: any, field: string) {
        const value = object[field];

        if (value === undefined) {
            return null;
        }
        switch (field) {
            case 'performance_score_average':
                return this.pipeService.get('monNumber')(value * 100, '0,0');
            default:
                return value;
        }
    }

    setShownMetrics () {
        if (!this.latestEntry) {
            return;
        }

        this.metrics = this.pagePerformanceVersionService.getVersionInfo(this.latestEntry.performance_version)?.metrics.map((metric: any) => {
            return {
                title: metric.label,
                unit: metric.unit,
                data: this.score[`performance_${metric.id}_average`],
                rulerClass: metric.rulerClass,
            };
        }) || [];
    }
}
